import isRecommendedPlanUtil from '../../../../modules/plan/model/utils/is-recommended'
import getCurrentPlanSelect from '../get-current'
import { createSelector } from 'reselect'

const isRecommendedPlanSelect = createSelector(getCurrentPlanSelect,
  (instance) => {
    return isRecommendedPlanUtil(instance)
  }
)

export default isRecommendedPlanSelect
